var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('autocomplete',{attrs:{"id":_vm.id,"url":_vm.config.services.companyHouse,"anchor":"title","min":3,"placeholder":_vm.placeholder,"title":_vm.title,"on-select":_vm.getData}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2a7cca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompaniesHouseInput.vue
// module id = AmDS
// module chunks = 1